import { I18nComponente } from "@/types/gerais"

export const OCriarRelatorioAtividadesi18n: I18nComponente = {
  "pt-BR": {
    configurarRelatorioDeAtividades: "configurar relatório de atividades",
    planilha: "planilha",
    arquivoDePagamento: "arquivo de pagamento",
    dataDeInicio: "data de inicio",
    dataDeFim: "data de fim",
    projetos: "projetos",
    profissionais: "profissionais",
    incluirInformacoesDeProfissionais:"incluir informações de profissionais sem registros no período",
    porFavorAguarde: "por favor aguarde um instante enquanto seu relatório é gerado",
    campoObrigatorio: "campo obrigatório*",
    erroAoCarregarProjetos: "Erro ao carregar projetos",
    ocorreuUmErroAoBuscarProjetos: "Ocorreu um erro ao buscar os projetos, tente novamente mais tarde.",
    erroAoCarregarProfissionais: "Erro ao carregar profissionais",
    ocorreuUmErroAoBuscarProfissionais: "Ocorreu um erro ao buscar os profissionais, tente novamente mais tarde.",
    camposInvalidos: "Campos inválidos",
    preenchaOsCamposCorretamente: "Preencha os campos corretamente e tente novamente",
    arquivoDePagamentoInicio: "arquivo-de-pagamento - inicio_",
    arquivoDePagamentoFim: " - fim_",
    erroAoGerarArquivoDePagamento: "Erro ao gerar o arquivo de pagamento",
    erroAoBaixarRelatorio: "Erro ao baixar relatório",
    tenteNovamenteMaisTarde: "Tente novamente mais tarde",
    cancelar: "cancelar",
    confirmar: "confirmar"
  },
  "es-CO": {
    configurarRelatorioDeAtividades: "configurar informe de actividades",
    planilha: "planilla",
    arquivoDePagamento: "archivo de pago",
    dataDeInicio: "fecha de inicio",
    dataDeFim: "fecha de fin",
    projetos: "proyectos",
    profissionais: "profesionales",
    incluirInformacoesDeProfissionais:"incluir información de profesionales sin registros en el período",
    porFavorAguarde: "por favor espere un momento mientras se genera su informe",
    campoObrigatorio: "campo obligatorio*",
    erroAoCarregarProjetos: "Error al cargar proyectos",
    ocorreuUmErroAoBuscarProjetos: "Ocurrió un error al buscar los proyectos, inténtelo de nuevo más tarde.",
    erroAoCarregarProfissionais: "Error al cargar profesionales",
    ocorreuUmErroAoBuscarProfissionais: "Ocurrió un error al buscar los profesionales, inténtelo de nuevo más tarde.",
    camposInvalidos: "Campos inválidos",
    preenchaOsCamposCorretamente: "Complete los campos correctamente e intente nuevamente",
    arquivoDePagamentoInicio: "archivo-de-pago - inicio_",
    arquivoDePagamentoFim: " - fin_",
    erroAoGerarArquivoDePagamento: "Error al generar el archivo de pago",
    erroAoBaixarRelatorio: "Error al descargar el informe",
    tenteNovamenteMaisTarde: "Inténtelo de nuevo más tarde",
    cancelar: "cancelar",
    confirmar: "confirmar"
  }
}
